import { AccountSignInSignUpSearchParams, inStoreSignUpConfigName } from '~constants/Constants';
import { BaseViewController, IBaseViewController } from '~exported/BaseViewController';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { IN_STORE_SIGN_UP_ROUTE } from '~routes/routes';
import { ConfigurationLoadedUseCase } from '~use-cases/ConfigurationLoadedUseCase';
import { SocialPageLoadedUseCase } from '~use-cases/social/SocialPageLoadedUseCase';
import { StoreReceiptExtractedUseCase } from '~use-cases/StoreReceiptExtractedUseCase';
import { TaggingEventSourceType } from '~utils/Analytics';
import { getSocialPageLoadType } from '~utils/SocialUtils';

export class RampViewController extends BaseViewController {
    private configRepository: ConfigRepository;

    constructor({
        routerStore,
        userRepository,
        configRepository
    }: IBaseViewController & {
        configRepository: ConfigRepository;
    }) {
        super({ routerStore, userRepository });
        this.configRepository = configRepository;
    }

    public loaded = async () => {
        super.init();
        const socialPageLoadType = getSocialPageLoadType();
        const {
            setSignUpEventSource,
            setSignInEventSource,
            loadSession,
            resetSession
        } = this.userRepository;
        const { rampCommon: { siteType } = {} } = this.configRepository;

        // Social login flow
        if (socialPageLoadType) {
            this.setIsLoading(true);
            await loadSession();
            try {
                new StoreReceiptExtractedUseCase().execute();
                await new SocialPageLoadedUseCase(socialPageLoadType).execute();
            } catch (error) {
                this.setError(error);
            }
            this.setIsLoading(false);

            return;
        }

        if (siteType === 'ecommerce') {
            await resetSession();
        }
        setSignUpEventSource(TaggingEventSourceType.IN_STORE);
        setSignInEventSource(TaggingEventSourceType.IN_STORE);
        new ConfigurationLoadedUseCase(inStoreSignUpConfigName).execute();
        this.routerStore.changeCurrentRoute(IN_STORE_SIGN_UP_ROUTE);
    };

    public getRedirectUrl = (urlParams: URLSearchParams): string => {
        return urlParams.get(AccountSignInSignUpSearchParams.REDIRECT_URL) || '';
    };
}
